#!/usr/bin/env node
import Compile from './src/compile';
export default require('./src/compile');